angular.module("MCmessageModule", [
    "collaborationMessageModule", //工作协同消息
    "resourceUpdateMessageModule", //资源更新消息
    "propagandaDepartmentMessageModule", //宣传部消息
    "systemMessageModule", //系统消息
    "messageReceivingConfigModule", //消息接收配置管理
    "messageRouterModule", //路由
    "msgServiceModule", //服务
    "mcMessageDetailModule", //消息详情
]);